import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IBOMSetupListResponse, IBOMSetupListResponseData } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useBOMSetupListAPI = () => {
  const [bomList, setBomList] = useState<IBOMSetupListResponseData[]>([]);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (query: string = "") => {
      dispatch(
        setLoading({
          key: "isBOMSetupListLoadingInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const searchKeywordParam = query ? `?bom_name=${query}` : "";
        await axios
          .get(`${INVENTORY_MODULE?.BOM_SETUP_LIST_API?.baseURL}${searchKeywordParam}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IBOMSetupListResponse>) => {
            if (res.data.status === true) {
              setBomList(res.data.data);
              dispatch(
                setLoading({
                  key: "isBOMSetupListLoadingInProgress",
                  status: false,
                }),
              );
            } else {
              setBomList([]);
              dispatch(
                setLoading({
                  key: "isBOMSetupListLoadingInProgress",
                  status: false,
                }),
              );
            }
          })
          .catch((e: AxiosError) => {
            setBomList([]);
            dispatch(
              setLoading({
                key: "isBOMSetupListLoadingInProgress",
                status: false,
              }),
            );
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        setBomList([]);
        dispatch(
          setLoading({
            key: "isBOMSetupListLoadingInProgress",
            status: false,
          }),
        );
        if (axios.isAxiosError(error)) {
          captureError(error);
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { execute, bomList };
};
